import { api } from '../api';
import authHelper from '../../helpers/auth.helper';
import { hydrateDetails, toggleLogin } from '../slices/user.slice';
import { setRequestAmendments } from '../slices/amendments.slice';

const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation({
      query: ({ data, loginAsAdmin = false }) => ({
        url: '/users/auth/',
        method: 'POST',
        data: { ...data, login_as_admin: loginAsAdmin },
      }),
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;
        authHelper.setToken(data.data.token);
        const userResult = await dispatch(api.endpoints.getUserDetails.initiate(undefined, { forceRefetch: true }));
        if (userResult.data) {
          dispatch(hydrateDetails(userResult.data));
        }
        dispatch(toggleLogin(true));
      },
    }),

    simpleLogin: build.mutation({
      query: ({ data, loginAsAdmin = false }) => ({
        url: '/users/auth/',
        method: 'POST',
        data: { ...data, login_as_admin: loginAsAdmin },
      }),
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;
        authHelper.setToken(data.data.token);
        const userResult = await dispatch(api.endpoints.getUserDetails.initiate(undefined, { forceRefetch: true }));
        if (userResult.data) {
          dispatch(hydrateDetails(userResult.data));
        }
        // Note: simpleLogin does NOT dispatch toggleLogin(true) — this is intentional.
        // Used for admin background auth.
      },
    }),

    getUserDetails: build.query({
      query: () => ({ url: '/users/self' }),
      providesTags: ['User'],
    }),

    getAmendments: build.query({
      query: (caseId) => ({ url: `/client-advisors/${caseId}/amendments/` }),
      transformResponse: (response) => response.data,
      providesTags: ['Amendments'],
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(setRequestAmendments(data));
        } catch {
          // No amendments is a valid state — backend returns 404. Consumers can
          // read `isError` from the query hook if they need to distinguish.
        }
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useSimpleLoginMutation,
  useGetUserDetailsQuery,
  useGetAmendmentsQuery,
  useLazyGetAmendmentsQuery,
} = userApi;
